import React, { useState, useEffect } from 'react';
// @mui material components
// import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
// import Box from "@mui/material/Box";
// import TextField from "@mui/material/TextField";
// import Button from "@mui/material/Button";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { DialogContentText } from "@mui/material";

import Backdrop from '@mui/material/Backdrop';
// import CircularProgress from '@mui/material/CircularProgress';

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { url, urlLive } from "../../constant";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

import { Grid, Box, FormControl, FormControlLabel, Checkbox, InputLabel, Select, MenuItem, TextField, Stack, Button, CircularProgress } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import 'dayjs/locale/en-gb'; // Import the locale for British English
import * as XLSX from 'xlsx';
import Link from '@mui/material/Link';

import { useLocation, useNavigate } from 'react-router-dom';

function Tables() {
  const [selectedTab, setSelectedTab] = useState(0);
  const [subscriptions, setSubscriptions] = useState([]);  // Stores the subscriptions data
  const [errors, setErrors] = useState({ name: "" });

  // Dialog states for delete and edit confirmation
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [deleteRequestId, setDeleteRequestId] = useState(null);
  const [deleteSubscriptionId, setDeleteSubscriptionId] = useState(null);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [editRequestId, setEditRequestId] = useState(null);
  const [editSubscriptionId, setEditSubscriptionId] = useState(null);
  const [currentPageIndex, setCurrentPageIndex] = useState(0); // Manage pagination state

  // New Subscription submit fields
  const [salesRep, setSalesRep] = React.useState('');
  const [salesReportName, setSalesReportName] = React.useState('');
  const [company, setCompany] = React.useState('');
  const [companyName, setCompanyName] = React.useState('');

  const [amount, setAmount] = React.useState('');

  const [dateStart, setDateStart] = React.useState(null);
  const [dateEnd, setDateEnd] = React.useState(null);
  const [publishDate, setPublishDate] = React.useState(null);
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState('');
  const [successMessage, setSuccessMessage] = React.useState('');
  const [companies, setCompanies] = React.useState([]);

  const [salesReports, setSalesReports] = React.useState([]);

  const [isLoading, setIsLoading] = React.useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  // Add loading states
  const [loading, setLoading] = useState(false);  // For fetching categories
  const [formLoading, setFormLoading] = useState(false);  // For form submission

  const navigate = useNavigate(); // Initialize the navigate function
  const locations = useLocation(); // Get the current URL location
  const queryParams = new URLSearchParams(locations.search); // Extract query parameters
  const activeTab = queryParams.get('activeTab'); // Get 'activeTab' query parameter

  //  console.log(activeTab == null ? 0 : activeTab);

  // Get user data from localStorage (user ID)
  const userData = localStorage.getItem('user');
  const user = userData ? JSON.parse(userData).user : null;
  const IsAdminPlatform = user ? user.IsAdminPlatform : null;

  // console.log(IsAdminPlatform);

  // Update window width on resize
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize); // Cleanup on unmount
  }, []);

  // Condition for styles
  const shouldHide = windowWidth <= 425 ? { display: 'none' } : { visibility: 'hidden' };
  const mtValue2 = windowWidth > 425 ? 2 : 0; // Set margin-top to 2 when the window width is above 425px, else 0.
  const mtValue3 = windowWidth > 425 ? 3 : 0; // Set margin-top to 2 when the window width is above 425px, else 0.


  useEffect(() => {

    if (activeTab != null) {
      setSelectedTab(parseInt(activeTab));
    }

  }, [activeTab]);

  // Fetch requests when the component mounts
  useEffect(() => {

    getSubscriptions();

  }, []);  // Empty dependency array to run only once when the component mounts


  const getSubscriptions = () => {

    setLoading(true);  // Show loader while fetching data
    const requestOptions = {
      method: "GET",
      redirect: "follow"
    };

    fetch(`${url}auth/get-subscriptions`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.message === "Subscriptions retrieved successfully.") {
          setSubscriptions(result.data); // Set the fetched Subscriptions data
        }
      })
      .catch((error) => console.error("Error fetching Subscriptions:", error))
      .finally(() => {
        setLoading(false);  // Hide loader after fetching
      });

  };


  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  // Fetch company and SalesReports options
  React.useEffect(() => {
    fetchCompanies();
    fetchSalesReports();

  }, []);

  const fetchCompanies = async () => {
    try {
      setIsLoading(true);
      const response = await fetch(`${url}auth/get-companies?IsActive=1`);
      const data = await response.json();
      setCompanies(data.companies || []);

    } catch (error) {
      console.error("Error fetching companies:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchSalesReports = async () => {

    try {
      setIsLoading(true);
      const response = await fetch(`${url}auth/get-sales-reps`);
      const data = await response.json();
      setSalesReports(data.sales_reports || []);
    } catch (error) {
      console.error("Error fetching categories:", error);
    } finally {
      setIsLoading(false);
    }

  };


  const handleSalesReportChange = (event) => {
    // Get the selected IdRequestCategory from the event
    const selectedId = event.target.value;

    // Find the corresponding RequestCategory from the categories array
    const selectedSalesReport = salesReports.find((salesReport) => salesReport.IdSalesRep === selectedId);

    // Set the category and categoryName state values
    setSalesRep(selectedId);
    setSalesReportName(selectedSalesReport ? selectedSalesReport.Name : ""); // If found, set the RequestCategory; else set an empty string
  };

  const handleCompanyChange = (event) => {
    // Get the selected IdCompany from the event
    const selectedId = event.target.value;

    // Find the corresponding CompanyName from the companies array
    const selectedCompany = companies.find((comp) => comp.IdCompany === selectedId);

    // Set the company and companyName state values
    setCompany(selectedId);
    setCompanyName(selectedCompany ? selectedCompany.CompanyName : ""); // If found, set the CompanyName; else set an empty string
  };


  const handleDateStartChange = (newValue) => {
    setDateStart(newValue);
  };

  const handleDateEndChange = (newValue) => {
    setDateEnd(newValue);
  };



  // Event Handlers
  const handleChange = (setter) => (event) => setter(event.target.value);
  const handleCheckboxChange = (setter) => (event) => setter(event.target.checked);


  // Form validation
  const validateForm = () => {
    const newErrors = {};

    if (!company) newErrors.company = "Azienda è obbligatorio.";
    if (!salesRep) newErrors.salesRep = "Sales Rep è obbligatorio.";
    if (!amount || amount <= 0) newErrors.amount = "Importo deve avere valori uguali o maggiori di 0.";
    if (!dateStart) newErrors.dateStart = "Start date is required.";
    if (!dateEnd) newErrors.dateEnd = "End date is required.";


    return Object.keys(newErrors).length === 0 ? true : newErrors;

  };


  // Function to show success or error message and hide it after a few seconds
  const showMessage = (type, message) => {
    if (type === 'success') {
      setSuccessMessage(message);
      setTimeout(() => {
        setSuccessMessage('');
      }, 3000); // Hide success message after 3 seconds
    } else if (type === 'error') {
      setErrorMessage(message);
      setTimeout(() => {
        setErrorMessage('');
      }, 3000); // Hide error message after 3 seconds
    }
  };

  // Handle submit
  const handleSubmit = () => {
    // Validate form before submission
    const validation = validateForm();

    if (validation !== true) {
      const errorMessage = Object.values(validation)[0];
      alert(errorMessage);
      return;
    }

    // Get the user ID from localStorage
    const user = JSON.parse(localStorage.getItem('user')); // Assuming user data is stored in localStorage
    if (!user || !user.user.IdUser) {
      alert('User not authenticated. Please log in.');
      return;
    }
    const userId = user.user.IdUser;
    const userEmail = user.user.email;

    // console.log(userEmail);

    // console.log(user);
    // Here you can make an API call or do whatever you'd like

    setIsSubmitting(true);
    setErrorMessage('');
    setSuccessMessage('');

    setFormLoading(true);  // Show loader during form submission

    // Create FormData
    const formdata = new FormData();

    formdata.append("IdCompany", company);
    formdata.append("IdSales", salesRep);
    formdata.append("Amount", amount);
    formdata.append("StartDate", dateStart ? dateStart.format('YYYY-MM-DD') : '');
    formdata.append("EndDate", dateEnd ? dateEnd.format('YYYY-MM-DD') : '');
    formdata.append("CreationUser", userId);  // Add the user ID to the form data

    const requestOptions = {
      method: "POST",
      body: formdata,
      redirect: "follow",
    };

    fetch(`${url}auth/create-subscriptions`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setIsSubmitting(false);
        if (result.message === "Subscriptions created successfully.") {
          // setSuccessMessage('Request created successfully!');
          showMessage('success', 'Subscriptions created successfully!')

          // Reset the form to initial state
          setSalesRep('');
          setCompany('');
          setAmount('');
          setDateStart(null);
          setDateEnd(null);


          // window.location.href = '/dashboard/request-list';
          getSubscriptions();
          setSelectedTab(0);

        } else if (result.error && result.messages) {
          // Check for validation errors
          let errorMessage = 'Please fix the following errors:\n';
          Object.entries(result.messages).forEach(([field, messages]) => {
            messages.forEach((msg) => {
              errorMessage += `- ${msg}\n`;
            });
          });
          alert(errorMessage);  // Show the validation error messages in an alert
        } else {
          // setErrorMessage('Failed to create request. Please try again.');
          showMessage('error', 'Failed to subscriptions request. Please try again.');

        }

      })
      .catch((error) => {
        setIsSubmitting(false);
        setErrorMessage('An error occurred while creating the subscriptions.');
        console.error(error);
      })
      .finally(() => {
        setFormLoading(false);  // Hide loader after form submission
      });


  }

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };


  // Function to handle truncation of description
  const truncatedDescription = (text, limit) => {
    if (text.length > limit) {
      return `${text.substring(0, limit)}...`;
    }
    return text;
  };

  const columns = [
    { Header: "ID", accessor: "IdSubscription" },
    // { Header: "Start Date", accessor: "StartDate" },
    { Header: "Data inizio", accessor: "StartDate" },
    // { Header: "End Date", accessor: "EndDate" },
    { Header: "Data Fine", accessor: "EndDate" },
    // { Header: "Company Name", accessor: "IdCompany" },
    { Header: "Azienda", accessor: "IdCompany" },
    // { Header: "Amount", accessor: "Amount" },
    { Header: "Importo", accessor: "Amount" },
    // { Header: "Sales Report Name", accessor: "IdSales" },
    { Header: "Sales Rep", accessor: "IdSales" },
    // { Header: "CreationDate", accessor: "CreationDate" },
    { Header: "Data creazione", accessor: "CreationDate" },
    // { Header: "UpdateDate", accessor: "UpdateDate" },
    { Header: "Data aggiornamento", accessor: "UpdateDate" },
    // { Header: "CreationUser", accessor: "CreationUser" },
    { Header: "Utente Creazione", accessor: "CreationUser" },
    // { Header: "UpdateUser", accessor: "UpdateUser" },
    { Header: "Utente aggiornamento", accessor: "UpdateUser" },

    // { Header: "Actions", accessor: "actions" },

    // Conditionally include Actions column based on IsAdminPlatform
    ...(IsAdminPlatform == 1 ? [
      { Header: "Actions", accessor: "actions" }
    ] : []),

  ];


  const rows = subscriptions.map((subscription, index) => ({
    IdSubscription: subscription.IdSubscription,
    StartDate: dayjs(subscription.StartDate).format('DD-MM-YYYY'),
    EndDate: dayjs(subscription.EndDate).format('DD-MM-YYYY'),
    IdCompany: subscription.CompanyName,
    IdSales: subscription.SalesReportName,
    Amount: subscription.Amount,
    CreationDate: dayjs(subscription.CreationDate).format('DD-MM-YYYY'),
    UpdateDate: subscription.UpdateDate ? dayjs(subscription.UpdateDate).format('DD-MM-YYYY') : '',
    CreationUser: subscription.CreationUserName,
    UpdateUser: subscription.UpdateUserName ? subscription.UpdateUserName : '',
    actions: IsAdminPlatform == 1 ? (
      <Box sx={{ display: 'flex', gap: 1 }}>
        {/* Edit Button */}
        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={() => handleEditDialogOpen(subscription)}
          sx={{
            fontWeight: 'bold',
            padding: '8px 16px',
            color: '#fff',
            // backgroundColor: '#1976d2',
            backgroundColor: '#183759',
            '&:hover': { 
              // backgroundColor: '#1565c0',
              backgroundColor: '#204b80',
             },
          }}
        >
          {/* Edit */}
          Modifica
        </Button>

        {/* Delete Button */}
        <Button
          variant="contained"
          color="error"
          size="small"
          onClick={() => handleDeleteDialogOpen(subscription.IdSubscription)}
          sx={{
            fontWeight: 'bold',
            padding: '8px 16px',
            backgroundColor: '#d32f2f',
            color: '#fff',
            '&:hover': { backgroundColor: '#c62828' },
          }}
        >
          {/* Delete */}
          Cancella

        </Button>
      </Box>
    ) : null,
  }));

  const handleEditDialogOpen = (subscription) => {
    console.log("edit-subscription", subscription);

    setEditSubscriptionId(subscription.IdSubscription); // Set the request ID (for submitting the edit)
    setCompany(subscription.IdCompany); // Set company, assuming request has a `CompanyId` field
    setSalesRep(subscription.IdSales); // Set request type, assuming request has a `IdSales` field
    setAmount(subscription.Amount); // Set Amount 
    setDateStart(subscription.StartDate); // Set start available date
    setDateEnd(subscription.EndDate); // Set end available date


    // Open the dialog
    setOpenEditDialog(true);
  };

  const handleEditDialogClose = () => {
    // Reset all the form fields to their default or empty state

    setEditSubscriptionId(null);
    setCompany(""); // Set company, assuming request has a `CompanyId` field
    setSalesRep(""); // Set request type, assuming request has a `IdSales` field
    setAmount(""); // Set Amount 
    setDateStart(null); // Set start available date
    setDateEnd(null); // Set end available date

    // Close the dialog
    setOpenEditDialog(false);

  };


  const handleEditSubmit = () => {
    if (validateForm()) {
      // Create a new FormData object and append all the form fields

      // Convert DateStartAvailable and DateEndAvailable to a consistent format
      const formattedStartDate = dayjs(dateStart).format("YYYY-MM-DD HH:mm:ss");
      const formattedEndDate = dayjs(dateEnd).format("YYYY-MM-DD HH:mm:ss");
      const formattedPublishDate = dayjs(publishDate).format("YYYY-MM-DD HH:mm:ss");

      // Get the user ID from localStorage
      const user = JSON.parse(localStorage.getItem('user')); // Assuming user data is stored in localStorage
      if (!user || !user.user.IdUser) {
        alert('User not authenticated. Please log in.');
        return;
      }
      const userId = user.user.IdUser;


      const formData = new FormData();

      formData.append("IdCompany", company); // Assuming company is a state variable (company ID)
      formData.append("IdSales", salesRep);

      formData.append("Amount", amount); // Assuming dailyRate is a state variable
      formData.append("StartDate", formattedStartDate); // Assuming dateStart is a state variable
      formData.append("EndDate", formattedEndDate); // Assuming dateEnd is a state variable
      formData.append("UpdateUser", userId);  // Add the user ID to the form data

      // Define request options with the FormData as the body and POST method
      const requestOptions = {
        method: "POST",
        body: formData,
        redirect: "follow"
      };

      // Make the API request to update the request data
      fetch(`${url}auth/update-subscriptions/${editSubscriptionId}`, requestOptions)
        .then((response) => response.json()) // Assuming JSON response
        .then((result) => {
          console.log(result);

          getSubscriptions();

          // window.location.reload();
          // Close the dialog after the update
          handleEditDialogClose();

        })
        .catch((error) => console.error("Error updating request:", error));
    }
  };


  const handleDeleteDialogOpen = (subscriptionId) => {
    setDeleteSubscriptionId(subscriptionId);
    setOpenDeleteDialog(true);
  };

  const handleDeleteDialogClose = () => {
    setDeleteSubscriptionId(null);
    setOpenDeleteDialog(false);
  };

  const handleDeleteConfirm = () => {
    const requestOptions = {
      method: "DELETE",
      redirect: "follow",
    };

    // Construct the URL dynamically using deleteSubscriptionId
    fetch(`${url}auth/delete-subscriptions/${deleteSubscriptionId}`, requestOptions)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Failed to delete subscription: ${response.statusText}`);
        }
        return response.json(); // Parse JSON response from the server
      })
      .then((result) => {
        console.log(result);  // This will log: { "message": "Request deleted successfully." }

        // If the message indicates success, update the state
        if (result.message === "Subscription deleted successfully.") {
          // Update the state to remove the deleted request
          setSubscriptions(subscriptions.filter((subscription) => subscription.IdSubscription !== deleteSubscriptionId));

          // Close the delete confirmation dialog
          setOpenDeleteDialog(false);

          // Optionally, you can show a success notification here
        } else {
          // Handle unexpected response or error message
          console.error("Unexpected response:", result);
        }
      })
      .catch((error) => {
        console.error("Error deleting subscription:", error);
        // Optionally, display a user-friendly error message here
      });
  };



  return (
    <DashboardLayout>
      <DashboardNavbar />

      {/* Loader Component */}
      <Backdrop open={loading || formLoading} sx={{ color: '#fff', zIndex: 1000 }}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                // bgColor="info"  
                bgColor="#183759"
                borderRadius="lg"
                coloredShadow="info"
              >
                {/* <MDTypography variant="h6" color="white">
                  Subscriptions
                </MDTypography> */}
                <MDTypography variant="h6" color="white">
                  Abbonamenti
                </MDTypography>
              </MDBox>

              <Box sx={{ width: '100%' }}>
                <Tabs
                  value={selectedTab}
                  onChange={handleTabChange}
                  indicatorColor="primary"
                  textColor="primary"
                  variant="fullWidth"
                  aria-label="basic tabs example"
                >
                  {/* <Tab label="List Subscriptions" />
                  <Tab label="Add Subscriptions" /> */}
                  <Tab label="Elenco Abbonamenti" />
                  <Tab label="Nuovo abbonamento" />
                </Tabs>

                {selectedTab === 0 && (
                  <MDBox pt={3}>

                    <DataTable
                      table={{ columns, rows }}
                      isSorted={false}
                      // entriesPerPage={false}
                      entriesPerPage={{ defaultValue: 10 }}
                      showTotalEntries={false}
                      noEndBorder
                      // canSearch
                      currentPageIndex={currentPageIndex}
                      setCurrentPageIndex={setCurrentPageIndex}
                    />

                  </MDBox>
                )}

                {selectedTab === 1 && (
                  <MDBox px={4} mx={2} mt={2}>
                    {/* <MDTypography variant="h6" mb={3} align="center">
                      Add New Subscriptions
                    </MDTypography> */}
                    <MDTypography variant="h6" mb={3} align="center">
                      Nuovo abbonamento
                    </MDTypography>

                    <Grid container spacing={3} justifyContent="center" alignItems="flex-start">

                      <Grid container spacing={3} justifyContent="center">


                        <Grid item xs={12} sm={6} md={4}>
                          <MDBox mt={2}>
                            <FormControl fullWidth>
                              <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
                                <DemoContainer components={['DatePicker']}>
                                  <DatePicker
                                    sx={{ width: '100%' }}
                                    label="Data inizio"
                                    value={dateStart}
                                    onChange={handleDateStartChange}

                                  />
                                </DemoContainer>
                              </LocalizationProvider>
                            </FormControl>
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                          <MDBox mt={mtValue2}>
                            <FormControl fullWidth>
                              <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
                                <DemoContainer components={['DatePicker']}>
                                  <DatePicker
                                    sx={{ width: '100%' }}
                                    label="Data Fine"
                                    value={dateEnd}
                                    onChange={handleDateEndChange}
                                  />
                                </DemoContainer>
                              </LocalizationProvider>
                            </FormControl>
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                          <MDBox mt={mtValue3}>
                            <FormControl fullWidth>
                              <InputLabel id="company-select-label">Azienda</InputLabel>
                              {/* <InputLabel id="company-select-label">Company</InputLabel> */}

                              <Select
                                labelId="company-select-label"
                                id="company-select"
                                value={company}
                                // disabled={IsAdminPlatform ? false : true}
                                label="Company"
                                onChange={handleCompanyChange}
                                style={{ height: 45 }}
                                sx={{
                                  '& .MuiSelect-icon': {
                                    display: 'block !important',  // Force icon to be visible
                                    fontSize: '1.6rem !important',  // Adjust the size of the dropdown icon
                                  },
                                }}
                                IconComponent={ArrowDropDownIcon}  // Ensures the dropdown icon is displayed
                              >
                                {isLoading ? (
                                  <MenuItem disabled>
                                    <CircularProgress size={24} sx={{ mr: 1 }} />
                                    Loading...
                                  </MenuItem>
                                ) : companies.length > 0 ? (
                                  companies.map((comp) => (
                                    <MenuItem key={comp.IdCompany} value={comp.IdCompany}>
                                      {comp.CompanyName}
                                    </MenuItem>
                                  ))
                                ) : (
                                  <MenuItem disabled>No companies available</MenuItem>
                                )}
                              </Select>

                            </FormControl>
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} sm={6} md={6}>
                          <MDBox>
                            <FormControl fullWidth>
                              <InputLabel id="sales-report-select-label">Sales Rep</InputLabel>


                              <Select
                                labelId="sales-report-select-label"
                                id="sales-report-select"
                                value={salesRep}
                                // label="Sales Report"
                                label="Sales Rep"
                                onChange={handleSalesReportChange}
                                style={{ height: 45 }}
                                sx={{
                                  '& .MuiSelect-icon': {
                                    display: 'block !important',  // Force icon to be visible
                                    fontSize: '1.6rem !important',  // Adjust the size of the dropdown icon
                                  },
                                }}
                                IconComponent={ArrowDropDownIcon}  // Ensures the dropdown icon is displayed
                              >
                                {isLoading ? (
                                  <MenuItem disabled>
                                    <CircularProgress size={24} sx={{ mr: 1 }} />
                                    Loading...
                                  </MenuItem>
                                ) : salesReports.length > 0 ? (
                                  salesReports.map((salesReport) => (
                                    <MenuItem key={salesReport.IdSalesRep} value={salesReport.IdSalesRep}>
                                      {salesReport.Name + " " + salesReport.Surname}
                                    </MenuItem>
                                  ))
                                ) : (
                                  <MenuItem disabled>No sales report available</MenuItem>
                                )}
                              </Select>

                            </FormControl>
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} sm={6} md={6}>
                          <MDBox >
                            <TextField
                              fullWidth
                              label="Importo"
                              // label="Amount"
                              variant="outlined"
                              type="number"
                              value={amount}
                              onChange={handleChange(setAmount)}
                            />
                          </MDBox>
                        </Grid>


                        <Grid item xs={12} >
                          <MDBox mt={3}>
                            <Stack spacing={2} mb={2} direction="row" justifyContent="flex-end">
                              <Button variant="contained"
                               onClick={handleSubmit}
                               sx={{
                                backgroundColor: '#183759',
                                '&:hover': {
                                  backgroundColor: '#204b80', // Subtle hover shade
                                },
                                transition: 'background-color 0.3s ease-in-out',
                                // textTransform: 'none'
                              }}
                              
                               >
                                {isSubmitting ? <a style={{ color: 'white' }}>Submitting...</a> :
                                  <a style={{ color: 'white' }}>Salva</a>}

                              </Button>
                            </Stack>
                          </MDBox>
                        </Grid>
                      </Grid>

                      {/* Display Success/Error Messages */}
                      {successMessage && (
                        <Grid item xs={12}>
                          <MDBox mt={1} mb={3} style={{ color: 'green' }}>
                            <MDTypography>{successMessage}</MDTypography>
                          </MDBox>
                        </Grid>
                      )}
                      {errorMessage && (
                        <Grid item xs={12}>
                          <MDBox mt={1} mb={3} style={{ color: 'red' }}>
                            <MDTypography>{errorMessage}</MDTypography>
                          </MDBox>
                        </Grid>
                      )}

                    </Grid>

                  </MDBox>
                )}
              </Box>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />

      {/* Delete Confirmation Dialog */}
      <Dialog open={openDeleteDialog} onClose={handleDeleteDialogClose} fullWidth maxWidth="sm">
        <DialogTitle>
          {/* Confirm Deletion */}
          Conferma l'eliminazione
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {/* Are you sure you want to delete this subscription? This action cannot be undone. */}
            Sei sicuro di voler eliminare questa abbonamento? Questa azione non può essere annullata.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteDialogClose} color="primary">
            {/* Cancel */}
            Annulla
          </Button>
          <Button onClick={handleDeleteConfirm} color="error">
            {/* Delete */}
            Cancella
          </Button>
        </DialogActions>
      </Dialog>


      {/* Edit Confirmation Dialog Modify */}
      <Dialog open={openEditDialog} onClose={handleEditDialogClose} fullWidth maxWidth="md">
        <DialogTitle>Modifica Abbonamento</DialogTitle>
        <DialogContent sx={{ paddingBottom: 3 }}>

          {/* Start Date */}
          <FormControl fullWidth sx={{ marginBottom: 2 }}>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
              <DemoContainer components={['DatePicker']}>
                <DatePicker
                  sx={{ width: '100%' }}
                  label="Data Inizio"
                  // label="Start Date"
                  value={dateStart ? dayjs(dateStart) : null}
                  onChange={handleDateStartChange}
                />
              </DemoContainer>
            </LocalizationProvider>
          </FormControl>

          {/* End Date */}
          <FormControl fullWidth sx={{ marginBottom: 2 }}>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
              <DemoContainer components={['DatePicker']}>
                <DatePicker
                  sx={{ width: '100%' }}
                  label="Data Fine"
                  // label="End Date"
                  value={dateEnd ? dayjs(dateEnd) : null}
                  onChange={handleDateEndChange}
                />
              </DemoContainer>
            </LocalizationProvider>
          </FormControl>


          {/* Company Field */}
          <FormControl fullWidth sx={{ marginBottom: 2 }}>
            <InputLabel id="company-select-label">Azienda</InputLabel>
            <Select
              labelId="company-select-label"
              id="company-select"
              value={company}
              label="Azienda"
              // label="Company"
              onChange={handleCompanyChange}
              style={{ height: 45 }}
              sx={{
                '& .MuiSelect-icon': {
                  display: 'block !important',  // Force icon to be visible
                  fontSize: '1.6rem !important',  // Adjust the size of the dropdown icon
                },
              }}
              IconComponent={ArrowDropDownIcon}  // Ensures the dropdown icon is displayed
            >
              {isLoading ? (
                <MenuItem disabled>
                  <CircularProgress size={24} sx={{ mr: 1 }} />
                  Loading...
                </MenuItem>
              ) : companies.length > 0 ? (
                companies.map((comp) => (
                  <MenuItem key={comp.IdCompany} value={comp.IdCompany}>
                    {comp.CompanyName}
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>No companies available</MenuItem>
              )}
            </Select>
          </FormControl>

          {/* Sales Report Field */}
          <FormControl fullWidth sx={{ marginBottom: 2 }}>
            <InputLabel id="sales-report-select-label">Sales Rep</InputLabel>


            <Select
              labelId="sales-report-select-label"
              id="sales-report-select"
              value={salesRep}
              label="Sales Rep"
              onChange={handleSalesReportChange}
              style={{ height: 45 }}
              sx={{
                '& .MuiSelect-icon': {
                  display: 'block !important',  // Force icon to be visible
                  fontSize: '1.6rem !important',  // Adjust the size of the dropdown icon
                },
              }}
              IconComponent={ArrowDropDownIcon}  // Ensures the dropdown icon is displayed
            >
              {isLoading ? (
                <MenuItem disabled>
                  <CircularProgress size={24} sx={{ mr: 1 }} />
                  Loading...
                </MenuItem>
              ) : salesReports.length > 0 ? (
                salesReports.map((salesReport) => (
                  <MenuItem key={salesReport.IdSalesRep} value={salesReport.IdSalesRep}>
                    {salesReport.Name + " " + salesReport.Surname}
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>No sales report available</MenuItem>
              )}
            </Select>

          </FormControl>


          {/* Amount */}
          <TextField
            fullWidth
            // label="Amount"
            label="Importo"
            variant="outlined"
            type="number"
            value={amount}
            onChange={handleChange(setAmount)}
            sx={{ marginBottom: 2 }}
          />

        </DialogContent>

        <DialogActions>
          <Button onClick={handleEditDialogClose} color="primary">
          Annulla
          </Button>
          <Button onClick={handleEditSubmit} color="primary">
          Salva
          </Button>
        </DialogActions>
      </Dialog>


    </DashboardLayout>
  );

}

export default Tables;
